
import React, { useState } from 'react';
import { Income, Expense } from '../types';

interface TransactionListProps {
  pemasukan: Income[];
  pengeluaran: Expense[];
  onDelete: (type: 'Pemasukan' | 'Pengeluaran', id: string) => void;
  isAdmin: boolean;
}

const TransactionList: React.FC<TransactionListProps> = ({ pemasukan, pengeluaran, onDelete, isAdmin }) => {
  const [activeTab, setActiveTab] = useState<'IN' | 'OUT'>('IN');

  return (
    <div className="bg-white">
      {/* Header Tabs */}
      <div className="p-6 border-b border-slate-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h3 className="text-lg font-bold text-slate-800">Riwayat Transaksi</h3>
          <p className="text-xs text-slate-400">Log lengkap aktivitas keuangan.</p>
        </div>
        <div className="flex p-1 bg-slate-50 rounded-xl w-full sm:w-auto">
          <button
            onClick={() => setActiveTab('IN')}
            className={`flex-1 sm:flex-none px-6 py-2 text-[10px] font-bold uppercase rounded-lg transition-all ${
              activeTab === 'IN' ? 'bg-white text-emerald-600 shadow-sm' : 'text-slate-400 hover:text-slate-600'
            }`}
          >
            Pemasukan
          </button>
          <button
            onClick={() => setActiveTab('OUT')}
            className={`flex-1 sm:flex-none px-6 py-2 text-[10px] font-bold uppercase rounded-lg transition-all ${
              activeTab === 'OUT' ? 'bg-white text-rose-600 shadow-sm' : 'text-slate-400 hover:text-slate-600'
            }`}
          >
            Pengeluaran
          </button>
        </div>
      </div>
      
      {/* Table Content */}
      <div className="overflow-x-auto custom-scrollbar">
        <table className="w-full text-left border-collapse min-w-[600px]">
          <thead className="bg-slate-50 text-slate-400 text-[10px] font-bold uppercase tracking-wider">
            <tr>
              <th className="px-6 py-4 rounded-tl-xl">Keterangan</th>
              <th className="px-6 py-4">Tanggal</th>
              <th className="px-6 py-4 text-right">Jumlah</th>
              {isAdmin && <th className="px-6 py-4 rounded-tr-xl text-right">Aksi</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {activeTab === 'IN' ? (
              pemasukan.length === 0 ? (
                <tr><td colSpan={isAdmin ? 4 : 3} className="px-6 py-12 text-center text-slate-400 text-xs italic">Belum ada data pemasukan.</td></tr>
              ) : (
                pemasukan.map((t, idx) => (
                  <tr key={t.ID} className="hover:bg-slate-50/80 transition-colors group">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center text-xs font-bold border border-emerald-100">
                          {t.Nama_Siswa.charAt(0)}
                        </div>
                        <div>
                          <p className="text-xs font-bold text-slate-700">{t.Nama_Siswa}</p>
                          <span className="text-[9px] px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">Bulan {t.Bulan}</span>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-xs font-medium text-slate-500">{t.Tanggal}</td>
                    <td className="px-6 py-4 text-xs font-bold text-right text-emerald-600">+Rp {t.Jumlah.toLocaleString('id-ID')}</td>
                    {isAdmin && (
                      <td className="px-6 py-4 text-right">
                         <button onClick={() => onDelete('Pemasukan', t.ID)} className="text-slate-300 hover:text-rose-500 transition-colors"><i className="fa-solid fa-trash"></i></button>
                      </td>
                    )}
                  </tr>
                ))
              )
            ) : (
              pengeluaran.length === 0 ? (
                <tr><td colSpan={isAdmin ? 4 : 3} className="px-6 py-12 text-center text-slate-400 text-xs italic">Belum ada data pengeluaran.</td></tr>
              ) : (
                pengeluaran.map((t, idx) => (
                  <tr key={t.ID} className="hover:bg-slate-50/80 transition-colors group">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center text-xs font-bold border border-rose-100">
                           <i className="fa-solid fa-bag-shopping"></i>
                        </div>
                        <div>
                          <p className="text-xs font-bold text-slate-700">{t.Keperluan}</p>
                          <span className="text-[9px] px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">Ops</span>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-xs font-medium text-slate-500">{t.Tanggal}</td>
                    <td className="px-6 py-4 text-xs font-bold text-right text-rose-600">-Rp {t.Jumlah.toLocaleString('id-ID')}</td>
                    {isAdmin && (
                      <td className="px-6 py-4 text-right">
                         <button onClick={() => onDelete('Pengeluaran', t.ID)} className="text-slate-300 hover:text-rose-500 transition-colors"><i className="fa-solid fa-trash"></i></button>
                      </td>
                    )}
                  </tr>
                ))
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionList;
